import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "count", "emptyNotice", "masterCheckbox"]
  static values = {
    masterCheckedWhen: { default: "all", type: String },
    // Leave checkboxes inside hidden rows (e.g. filtered out by list-filter) alone.
    visibleOnly: Boolean,
  }

  checkAll() {
    this.#setAll(true)
  }

  connect() {
    this.updateMaster()
  }

  toggle = (e) => {
    if (!this.hasMasterCheckboxTarget) {
      return
    }

    this.#setAll(e?.currentTarget?.checked ?? this.masterCheckboxTarget.checked)
  }

  uncheckAll() {
    this.#setAll(false)
  }

  updateCount() {
    const selected = this.checkboxTargets.filter((target) => target.checked).length

    this.countTargets.forEach((target) => {
      target.innerText = selected
    })

    this.emptyNoticeTargets.forEach((target) => {
      target.hidden = selected > 0
    })

    this.dispatch("count", {
      detail: { selected, total: this.checkboxTargets.length },
    })
  }

  updateMaster() {
    this.updateCount()

    if (!this.hasMasterCheckboxTarget) {
      return
    }

    const enabledCheckboxes = this.checkboxTargets.filter((checkbox) => this.#togglable(checkbox))

    if (enabledCheckboxes.length === 0) {
      this.masterCheckboxTargets.forEach((checkbox) => {
        checkbox.checked = false
      })
      return
    }

    const checked = this.masterCheckedWhenValue === "any"
      ? enabledCheckboxes.some((checkbox) => checkbox.checked)
      : enabledCheckboxes.every((checkbox) => checkbox.checked)

    this.masterCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }

  #setAll(checked) {
    this.checkboxTargets.forEach((checkbox) => {
      if (!this.#togglable(checkbox)) return

      checkbox.checked = checked
    })

    this.updateMaster()
  }

  #togglable(checkbox) {
    return !checkbox.disabled && !(this.visibleOnlyValue && checkbox.closest(".hidden, [hidden]"))
  }
}
